<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> > 
            <h1 class="h3 mb-2 mt-2 text-gray-800">中心成員管理</h1>

            <Msg :message="message" :is_error="is_error"></Msg>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>

            <div class="card shadow mb-4" v-if="!loading" >
              <div class="card-header py-3">
              <button type="button" class="btn btn-primary" v-on:click="Add">新增</button>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  
                  <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                      <tr>
                        <th width="20%">職稱</th>
                        <th width="60%">成員姓名</th>
                        <th style='min-width:150px'>功能</th>
                        <th>排序</th>
                      </tr>
                    </thead>
                    <draggable v-model="datas" tag="tbody" group="people" @start="drag=true" @end="drag=false;Update()" :disabled="disabled" >
                       
                        <tr v-for="(item) in datas" :key="item.id">
                          <td>{{item.data.job_title}}</td>
                          <td>{{item.data.name}}</td>
                          <td>
                            <button type="button" class="btn btn-primary" v-on:click="Edit(item.id)">編輯</button>
                            <button type="button" class="btn btn-danger" v-on:click="Delete(item.id)">刪除</button>
                          </td>
                          <td>
                            <label style="cursor:grab"><i class="fas fa-sort"></i></label>
                          </td>
                        </tr>
                    </draggable>
                  </table>
                </div>
              </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Draggable from 'vuedraggable'
export default {
  name: 'Faculty',
  components: {
    Draggable
  },
  data () {
    return {
      datas:[],
      disabled:false,
      loading:true,
      message:'',
      is_error:false
    }
  },
  mounted () {
    this.Get();
  },
  methods: {
    Get(){
        this.datas = [];
        var vm = this;
        // 取得列表
        db.collection("faculty").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                var data = {"id": doc.id, "data": doc.data()};
                
                this.datas.push(data);
            });
            this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
            this.loading = false;

            if ($.fn.DataTable.isDataTable('#dataTable')) {
              $('#dataTable').dataTable().fnClearTable();
              $('#dataTable').dataTable().fnDestroy();
            }

            vm.EnableTable();
            
        });
    },
    Add() {
      this.$router.push({name: 'FacultyAdd'});
    },
    Edit(id) {
      this.$router.push({ name: 'FacultyEdit', params: { id: id }});
    },
    Delete(id) {
      if ( confirm("確定要刪除?") ) {
        db.collection("faculty").doc(id).delete()
        .then(() => {
            alert("刪除成功!");
            this.Get();
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    Update() {
      this.Beforesend();
      this.disabled = true;
      var batch = db.batch();

      var total = this.datas.length;
      this.datas.forEach(function(value, index, array){
        // Update the population of 'SF'
        var sfRef = db.collection("faculty").doc(value.id);
        batch.update(sfRef, {"order": total});
        total--;
        
      });

      batch.commit()
      .then(() => {
        this.disabled = false;
        this.message = "排序更新成功";
        this.is_error = false;
        this.Aftersend();
      }).catch(()=>{
        this.disabled = false;
        this.message = "排序更新成功";
        this.is_error = true;
        this.Aftersend();
      });
    }
  }
}
</script>
<style scoped>
.title, .item{
    border-bottom:1px solid #e3e6f0
}
.title {
    font-weight: 700;
}
th,td {
  border-top:1px solid #e3e6f0 !important;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
}
th:last-child,td:last-child {
  border-right:1px solid #e3e6f0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Faculty.vue